class CartHsa extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.handleClick);
    this.addEventListener('keydown', this.handleKeyDown);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleClick);
    this.removeEventListener('keydown', this.handleKeyDown);
  }

  handleClick = (event) => {
    const dialog = this.querySelector('dialog');
    // Keep the parent cart drawer open while using its nested information dialog.
    event.stopPropagation();
    if (event.target.closest('[data-hsa-open]')) dialog.showModal();
    if (event.target.closest('[data-hsa-close]')) dialog.close();
    if (event.target === dialog) {
      const bounds = dialog.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
    }
  };

  handleKeyDown = (event) => {
    if (event.key === 'Escape' && this.querySelector('dialog').open) event.stopPropagation();
  };
}

if (!customElements.get('rm-cart-hsa')) customElements.define('rm-cart-hsa', CartHsa);
